import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tab-pane fade active show",
  role: "tabpanel"
}
const _hoisted_2 = { class: "card card-flush mb-6 mb-xl-9" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header mt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title flex-column" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "mb-1" }, "Preferred skills")
  ])
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_transfer = _resolveComponent("el-transfer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_ctx.client)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_transfer, {
                class: "w-100 d-flex",
                modelValue: _ctx.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
                filterable: "",
                onChange: _ctx.handleSave,
                titles: ['Skills', 'Preferred skills'],
                "filter-method": _ctx.filterMethod,
                "filter-placeholder": "Search skills",
                data: _ctx.data
              }, null, 8, ["modelValue", "onChange", "filter-method", "data"])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}